<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-body">
        <h1 class="dashboard-panel__title">
          Contratos Digitais
        </h1>
        <p class="admin-page-description">
          Contratos digitais cadastrados para a instituição. Liste os
          contratos ativos, desabilite os obsoletos e crie novos templates
          pra serem usados em matrículas e rematrículas.
        </p>
        <digital-contracts-table
          class="dashboard-panel__digital-contracts"
          :digital-contracts="digitalContracts"
          @digital-contract-disabled="loadContracts()"
        />
        <div class="row">
          <div class="col-xs-12 text-right">
            <button class="btn btn-default" @click="showDigitalContractModal = true">
              Criar contrato digital
            </button>
          </div>
        </div>
        <digital-contract-modal
          v-if="showDigitalContractModal"
          @digital-contract-created="loadContracts()"
          @close="showDigitalContractModal = false"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';

  .dashboard-panel__digital-contracts {
    margin-bottom: $space-m;
  }
</style>
<script>
import { mapState } from 'vuex';
import InstitutionDigitalContractsService from 'services/InstitutionDigitalContractsService';
import DigitalContractsTable from './components/DigitalContractsTable';
import DigitalContractModal from './modals/DigitalContractModal';

export default {
  components: {
    DigitalContractModal,
    DigitalContractsTable,
  },
  computed: {
    ...mapState([
      'institution',
    ]),
  },
  data() {
    return {
      digitalContracts: [],
      showDigitalContractModal: false,
    };
  },
  mounted() {
    this.loadContracts();
  },
  methods: {
    loadContracts() {
      this.$loader.show();
      InstitutionDigitalContractsService.getDigitalContracts(this.institution.id)
        .then((response) => {
          this.digitalContracts = response.institutionDigitalContractsList;
        })
        .catch(() => {
          this.$alert.notifyAlert('Erro ao buscar informações, tente novamente mais tarde');
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
  },
};
</script>
